import { LogOut } from "lucide-react";
import { Brand } from "./Brand";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export function AppHeader({ right }) {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-[#E5E2DC] bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <Brand subtitle={false} />
        <div className="flex items-center gap-3">
          {right}
          <div className="hidden text-right sm:block">
            <div className="text-sm font-medium text-[#1F2924]">{user?.name}</div>
            <div className="text-xs text-[#515E58]">{user?.email}</div>
          </div>
          <Button variant="outline" size="sm" onClick={logout} data-testid="logout-btn"
            className="gap-2 border-[#E5E2DC] text-[#515E58] hover:bg-[#F4F2EC]">
            <LogOut className="h-4 w-4" /> Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}
